<script lang="ts">
  import type { Distributor } from "@shared/types/Distributor";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import Flash from "@shared/services/flashv2.js";
  import FlashWrapper from "@shared/svelte/Components/Flash/Wrapper.svelte";
  import Header from "@onboarding2/svelte/Shared/Header.svelte";
  import FormStepper from "@onboarding2/svelte/Shared/FormStepper.svelte";
  import StepperFooter from "@onboarding2/svelte/Shared/StepperFooter.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import RepsPerDistributor from "@onboarding2/svelte/SalesRep/RepsPerDistributor.svelte";
  import SalesforceChat from "@shared/services/salesforce_chat";
  import PageTitle from "@shared/svelte/Components/PageTitle.svelte";

  const { immediatelyProcessEventQueue } = EventTracking;

  export let distributors: Distributor[] = [];

  const save = async (): Promise<void> => {
    await immediatelyProcessEventQueue();
    window.location.reload();
  };
  setTimeout(function () {
    SalesforceChat.hide();
  }, 1000);

  const addSalesRepErrorCallback = () => {
    Flash.now({
      message: "Sorry - we had a problem. Please try again or contact support.",
      type: "error",
    });
  };
</script>

<style>
  @media (min-width: 1000px) {
    #info {
      position: absolute;
      left: 100%;
      width: 100%;
      max-width: 210px;
      transform: translateX(16px);
    }
  }
</style>

<PageTitle title="Your sales reps - Sign up | Provi" />
<body class="fizz-layout-1-col-narrow-header-footer">
  <Header title={"Account setup"}>
    <FormStepper currentStep={3} />
  </Header>

  <main data-grid-area="main">
    <h2 class="fizz-heading-3 fizz-stack-8 fizz-text-center-on-large">
      Finally, who are your sales reps?
    </h2>
    <p class="fizz-stack-32 fizz-text-center-on-large fizz-text-medium">
      Your sales reps are still involved! We'll send all your orders to them.
    </p>

    <div class="fizz-relative">
      <div
        class="fizz-surface-gray fizz-inset-square-16 fizz-radius-medium fizz-stack-32"
        id="info"
      >
        <p class="fizz-flex-row-4 fizz-text-small fizz-stack-12">
          <Icon type="Lightbulb" height="14" width="14" />
          <strong>Tip: How to find your reps</strong>
        </p>
        <ol class="fizz-ordered-list fizz-flow-8 fizz-text-small">
          <li>
            Give the distributor a quick call and they will let you know who your sales rep is.
          </li>
          <li>Sales rep contact information can be found on distributor invoices.</li>
        </ol>
      </div>

      {#each distributors as distributor}
        <RepsPerDistributor {distributor} {addSalesRepErrorCallback} />
      {/each}
    </div>
  </main>

  <StepperFooter backState={"layout.signedIn.distributors"} nextFn={() => save()} />
  <FlashWrapper />
</body>
